mutation UpdateSageGiftAccountRecord(
  $sageGiftAccountId: ID!
  $fundAccountId: ID
  $syncSageJournalEntries: Boolean!
) {
  updateSageGiftAccountRecord(
    input: {
      sageGiftAccountId: $sageGiftAccountId
      fundAccountId: $fundAccountId
      syncSageJournalEntries: $syncSageJournalEntries
    }
  ) {
    success
  }
}
